webpackJsonp([159505736697540],{

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(17);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _components = __webpack_require__(8);
	
	var _data = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'A partnership is a legal form of business operation between two or more individuals who share management and profits. The federal government recognizes several types of partnerships. The two most common are general and limited partnerships.'
	    )
	  );
	};
	
	var fieldSets = [{
	  legend: 'Partnership Information',
	  fields: new Map([['orgName', {
	    label: 'Partnership Name',
	    title: 'Please enter the name of the partnership',
	    'data-help-title': 'Partnership Name',
	    'data-help-text': 'Please enter the name of the partnership.',
	    validation: Yup.string().required('Please enter the name of the partnership')
	  }], ['dba', {
	    label: 'Trade Name / DBA',
	    'data-help-text': 'Please enter the trade name of the partnership.'
	  }]])
	}, {
	  legend: 'Primary Partner Information',
	  fields: new Map([['firstName', {
	    'data-help-title': 'General Partner',
	    'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.'
	  }], ['middleName', {
	    'data-help-title': 'General Partner',
	    'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.'
	  }], ['lastName', {
	    'data-help-title': 'General Partner',
	    'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.'
	  }], ['socialSecurity', {
	    'data-help-title': 'General Partner',
	    'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.'
	  }], ['verifySocialSecurity', {
	    'data-help-title': 'General Partner',
	    'data-help-text': 'A General Partner is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.'
	  }], ['title', {
	    label: "Partner's Title",
	    placeholder: 'Mangaing Member',
	    'data-help-title': 'Mangaing Member',
	    'data-help-text': 'A Mangaing Member is the owner with the most control over the Partnership. If control is equally distributed among multiple owners, enter only one.'
	  }], ['suffix', {
	    initial: 'DDS'
	  }]])
	}, {
	  legend: 'Business Address (No PO Boxes)',
	  fields: new Map([['businessAddress'], ['businessCity'], ['businessState'], ['businessZip'], ['businessCounty'], ['mailingAddressDiff']])
	}, {
	  legend: 'Business Information',
	  fields: new Map([['businessApplyReason'], ['businessActivity'], ['businessServices'], ['businessHireEmployees']])
	}, {
	  legend: 'Business Dates',
	  fields: new Map([['businessDateStart'], ['businessClosingMonth']])
	}, {
	  legend: 'Contact Information',
	  fields: new Map([['customerContactPhone'], ['customerContactEmail'], ['customerContactEmailVerify', {
	    label: 'Verify Contact E-mail'
	  }]])
	}];
	
	var PartnershipApplicationPage = function PartnershipApplicationPage(props) {
	  return _react2.default.createElement(_components.ApplicationFlow, _extends({
	    step: 2,
	    title: 'Partnership Application',
	    documentType: _data.documentTypes.PARTNERSHIP,
	    description: Description,
	    fieldSets: fieldSets
	  }, props));
	};
	
	exports.default = PartnershipApplicationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-partnership-application-js-3c78b0581c184c63b20f.js